import React from "react";
import { ShieldCheck, Landmark, Coins } from "lucide-react";

/**
 * Compact "verified badges" strip.
 * Used on project cards, project detail pages, and story cards.
 */
export default function VerificationBadges({ compact = false }) {
  const items = [
    { i: <ShieldCheck size={compact ? 12 : 14}/>, t: "Title Checked" },
    { i: <Landmark    size={compact ? 12 : 14}/>, t: "Government-Aligned" },
    { i: <Coins       size={compact ? 12 : 14}/>, t: "Fixed Price · No Haggling" },
  ];
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="verification-badges">
      {items.map((b) => (
        <span key={b.t}
              className={`inline-flex items-center gap-1 rounded-full font-semibold ${compact ? "text-[9.5px] px-1.5 py-0.5" : "text-[10.5px] px-2 py-1"}`}
              style={{ background: "rgba(37,211,102,0.12)", color: "#0A7A2C" }}>
          {b.i} {b.t}
        </span>
      ))}
    </div>
  );
}
